/// <reference path='../_all.ts' />

module editor {
  'use strict';

  /**
   * Services that persists and retrieves TODOs from localStorage.
   */
  export class EditorService implements IEditorService {

    // $inject annotation.
    // It provides $injector with information about dependencies to be injected into constructor
    // it is better to have it close to the constructor, because the parameters must match in count and type.
    // See http://docs.angularjs.org/guide/di
    public static $inject = [
      '$rootScope',
      '$http',
      '$q',
      'Upload',
    ];

    constructor(
      private $rootScope: ng.IRootScopeService,
      private $http: ng.IHttpService,
      private $q: ng.IQService,
      private Upload: ng.angularFileUpload.IUploadService
      ) {}


    private data: EditorFilter;

    private getFilterParams(data: EditorFilter): any {
      var prm = {};
      prm["Category"] = data.Category;

      if (data.IsLanguageIndifferent === true)  { prm["IsLanguageIndifferent"] = true; }  

      if (typeof data.ContentId !== 'undefined') { prm["ContentId"] = data.ContentId }  

      if (typeof data.Filter1 !== 'undefined') { prm["Filter1"] = data.Filter1; }  
      if (typeof data.Filter2 !== 'undefined') { prm["Filter2"] = data.Filter2; }  
      if (typeof data.Filter3 !== 'undefined') { prm["Filter3"] = data.Filter3; }  

      if (data.FilterString1) { prm["FilterString1"] = data.FilterString1; }  //no encodeURIComponent because we use prm => otherwise double encoding
      if (data.FilterString2) { prm["FilterString2"] = data.FilterString2; }  
      if (data.FilterString3) { prm["FilterString3"] = data.FilterString3; } 
       
      return prm;
    }

    public edit(data : EditorFilter) :void {
      this.data = data;
      this.$rootScope.$emit('editor-edit-event', data);
    }

    public subscribeOnEdit(scope : ng.IScope, callback: any) : void {
      var handler = this.$rootScope.$on('editor-edit-event', callback);
      if (scope) scope.$on('$destroy', handler);
    }

    public notify() {
        this.$rootScope.$emit('notifying-service-event');
    }

    public subscribeOnSaveContent(
      scope : ng.IScope
      , callback: (event: ng.IAngularEvent, filter : EditorFilter, data : string) => void
      ) {

      var handler = this.$rootScope.$on('editor-save-event', callback); 
      if (scope) scope.$on('$destroy', handler);
    }


    
    public saveContent(filter: EditorFilter, content: Content, hl? : ILanguageInfo) : ng.IHttpPromise<Content>  {     
      
      var prm = this.getFilterParams(filter);
          
      return this.$http<Content>({
        method: "POST"
        , url: "/api/" + (hl || pglob.RouteData.CurrentLanguage).hl + "/Content/"
        , headers: { 'Content-Type': 'application/json' }
        , params: prm
        , data: {
          ContentType: content.ContentType.charCodeAt(0),  
          Content: content.Content,
          ContentMeta: content.ContentMeta,
          Excerpt: content.Excerpt
        }
      }).then((response) :ng.IHttpResponse<Content> => { //success
        this.StringFieldsToDate(response.data, hl); //we recieve that as string, have to convert it.
        this.$rootScope.$emit('editor-save-event', filter, response.data.ContentHtml);
        return response;
      });

    }

    public createContent(hl: ILanguageInfo, type : ContentType, filter : EditorFilter, tags?: ContentTag[]): ng.IHttpPromise<Content> {

      var prm = this.getFilterParams(filter);
      prm['ContentType'] = type.charCodeAt(0);
      prm['TagIds'] = [];

      if (tags) {
        tags.forEach((t, i, arr) => {
          prm['TagIds'].push(t.Id);
        });
      }

      return this.$http<Content>({
        method: "GET"
        , url: "/api/" + (hl || pglob.RouteData.CurrentLanguage).hl + "/Content/CreateContent"
        , headers: { 'Content-Type': 'application/json' }
        , params: prm
        , data: {}
      }).then((response): ng.IHttpResponse<Content> => {
        this.StringFieldsToDate(response.data, hl); //we recieve that as string, have to convert it.
        return response;
      })

    }

    /**
     * Returns Content With Type. Attention: Metadata is not returned!
     * @param content
     * @param destformat    
     */
    public convertContent(content: Content, destformat: ContentType): ng.IHttpPromise<Content> {

      return this.$http<Content>({
        method: "POST"
        , url: "/api/" + pglob.RouteData.CurrentLanguage.hl + "/Content/Convert"
        , headers: { 'Content-Type': 'application/json' }
        , params: {
          dstFormat: destformat.charCodeAt(0),
        } 
        , data: {
          ContentType : content.ContentType.charCodeAt(0),  
          Content: content.Content,
        }
      }).then((response) => {
        this.StringFieldsToDate(response.data, pglob.RouteData.CurrentLanguage); //we recieve that as string, have to convert it.
        return response;
      });


    }

    public changeStatus(contentId: number, destStatus: ContentMetaStatus, hl : ILanguageInfo): ng.IHttpPromise<Content> {
      return this.$http<Content>({ 
        method: "GET"
        , url: "/api/" + (hl || pglob.RouteData.CurrentLanguage).hl + "/Content/Status"
        , headers: { 'Content-Type': 'application/json' }
        , params: {
          dstStatus: destStatus, 
          id : contentId
        }
      }).then((response) => {
        this.StringFieldsToDate(response.data, hl); //we recieve that as string, have to convert it.
        return response;
      })
    }

    

    public loadContent(data: EditorFilter, hl : ILanguageInfo, desiredTypeIfNew : ContentType) : ng.IHttpPromise<Content> {    

      var prm = this.getFilterParams(data);
      prm.desiredContentTypeIfNew = desiredTypeIfNew ? desiredTypeIfNew.charCodeAt(0) : null;
          
      return this.$http<Content>({
        method: "GET"
        , url: "/api/" + (hl || pglob.RouteData.CurrentLanguage).hl + "/Content/"
        , headers: { 'Content-Type': 'application/json' }
        , params: prm
      }).then((response) => {
        if (response && response.data) {
          this.StringFieldsToDate(response.data, hl); //we recieve that as string, have to convert it.
        }
        return response;
      });
       
    }  


    public loadContentMany(data: EditorFilter, hl?: ILanguageInfo): ng.IHttpPromise<Content[]> {
      var prm = this.getFilterParams(data);      
      
      return this.$http<Content[]>({
        method: "GET"
        , url: "/api/" + (hl || pglob.RouteData.CurrentLanguage).hl + "/Content/GetExtended"
        , headers: { 'Content-Type': 'application/json' } 
        , params: prm
      }).then((response) => {
        response.data.forEach((v) => {
          this.StringFieldsToDate(v, hl);
        });
        return response; 
      })

    }

    public loadRessources(data: EditorFilter) : ng.IHttpPromise<Ressource[]> {
      var prm = this.getFilterParams(data);      
          
      return this.$http<Ressource[]>({
        method: "GET"
        , url: "/api/" + pglob.RouteData.CurrentLanguage.hl + "/Content/Ressouces"
        , headers: { 'Content-Type': 'application/json' }
        , params: prm
      });

    }   


    public loadTags(hl : ILanguageInfo) : ng.IHttpPromise<ContentTag[]> {      
          
      return this.$http<ContentTag[]>({
        method: "GET"
        , url: "/api/" + pglob.RouteData.CurrentLanguage.hl + "/Content/Tags"
        , headers: { 'Content-Type': 'application/json' }
        , params: { }
      }).then((response) => {
        if (response && response.data) {
          response.data.forEach((t, i, a) => {
            t._displayname = t.Name;
            if (t.Names && t.Names[hl.hlFull]) {
              t._displayname = t.Names[hl.hlFull];
            }
            t._lowerdisplayname = t._displayname.toLowerCase();
          })
        }
        return response;
      });

    }   

    
    public saveRessources(filter: EditorFilter, data: Ressource[]) : ng.IHttpPromise<void> {
      var prm = this.getFilterParams(filter);      
          
      return this.$http({
        method: "POST"
        , url: "/api/" + pglob.RouteData.CurrentLanguage.hl + "/Content/Ressouces"
        , headers: { 'Content-Type': 'application/json' }
        , params: prm
        , data: data
      });

    }   
    
    
    public clearCache() : ng.IHttpPromise<void> {  
      return this.$http<void>({
        method: "GET"
        , url: "/api/" + pglob.RouteData.CurrentLanguage.hl + "/Content/ClearCache"
        , headers: { 'Content-Type': 'application/json' }
        , params: { }
      });
    }
    
    
    public loadFilter(categoryId : number[]) : ng.IHttpPromise<EditorFilter[]> {  
      var query = "";
      categoryId.forEach((v : number) => { query += "categoryId=" + v + "&" });
          
      return this.$http<EditorFilter[]>({
        method: "GET"
        , url: "/api/" + pglob.RouteData.CurrentLanguage.hl + "/Content/ContentFilter?" + query
        , headers: { 'Content-Type': 'application/json' }
        , params: { }
      });
    }    
    
    public createMissingContent() : ng.IHttpPromise<void> {  
      return this.$http<void>({
        method: "GET"
        , url: "/api/" + pglob.RouteData.CurrentLanguage.hl + "/Content/CreateMissingContent"
        , headers: { 'Content-Type': 'application/json' }
        , params: { }
      });
    }

    public removeContentFile(id: number, type: ContentAttachementType, hl?: ILanguageInfo): ng.IHttpPromise<Content> {
      return this.$http<Content>({
        method: 'POST'
        , url: "/api/" + (hl || pglob.RouteData.CurrentLanguage).hl + "/Upload/RemoveFile"
        , params: { 
          id : id,
          contenttype : type,
        }
      });
    }

    public uploadFile(file : any, type : ContentAttachementType, contentId : number, ext : string, hl?: ILanguageInfo ) :  ng.angularFileUpload.IUploadPromise<Content> {
      var extension = file.name.substring(file.name.lastIndexOf(".") + 1);
      return this.Upload.upload<Content>({
        method: 'POST'
        , url: "/api/" + (hl || pglob.RouteData.CurrentLanguage).hl + "/Upload/UploadFile"
        , data: { 
          file: [file] 
        }
        , params: { 
          extension : extension,
          id : contentId,
          contenttype : type,
        }
      });
    }

    
    /**
     * Changes Date Fields that we receive as string to datetime
     * @param response
     */
    private StringFieldsToDate(c : Content, hl : ILanguageInfo) {
      c.ContentType = <ContentType>String.fromCharCode(<any>c.ContentType);
      if (!c.ContentMeta) return;

      if (c.ContentMeta.CreatedAt) c.ContentMeta.CreatedAt = new Date(<any>c.ContentMeta.CreatedAt); //we recieve that as string, have to convert it.
      if (c.ContentMeta.ModifiedAt) c.ContentMeta.ModifiedAt = new Date(<any>c.ContentMeta.ModifiedAt); //we recieve that as string, have to convert it.
      if (c.ContentMeta.PublishedAt) c.ContentMeta.PublishedAt = new Date(<any>c.ContentMeta.PublishedAt);
      if (c.ContentMeta.ValidFrom) c.ContentMeta.ValidFrom = new Date(<any>c.ContentMeta.ValidFrom);
      if (c.ContentMeta.ValidTo) c.ContentMeta.ValidTo = new Date(<any>c.ContentMeta.ValidTo);

      if (c.ContentMeta.ValidFrom.getFullYear() < 1800) c.ContentMeta.ValidFrom = null;
      if (c.ContentMeta.ValidTo.getFullYear() > 9000) c.ContentMeta.ValidTo = null;




       if (c.ContentMeta.Tags) {
          c.ContentMeta.Tags.forEach((t, i, a) => {
            t._displayname = t.Name;
            if (t.Names && t.Names[hl.hlFull]) {
              t._displayname = t.Names[hl.hlFull];
            }
            t._lowerdisplayname = t._displayname.toLowerCase();
          });
        }
    }

  }
}